import React, { useEffect, useState} from 'react';
import {SelectValidator, TextValidator, ValidatorForm} from "react-material-ui-form-validator";
import ColAtm from "../../../atomic/Col/Col";
import {FormControl, Grid, MenuItem, Select, InputLabel, TextField, Tooltip, Snackbar} from "@material-ui/core";
import {useDispatch, useSelector} from "react-redux";
import ButtonAtm from "../../../atomic/Button/Button";
import {
    createPlace,
    getPlaceList,
    createPlaceClearStatus,
    getPlaceCategoryFields,
    getPlaceCategoryFieldsClearStatus
} from "../../../../redux/actions/Content/Places/placesActions"
import {useTranslation} from "react-i18next";
import {Alert} from "@material-ui/lab";
import {convertAccentedCharacters, isDefined, getPropertyName} from "../../../../utils";
import AppBar from "@material-ui/core/AppBar/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import PropTypes from "prop-types";
import InputAtm from "../../../atomic/Input/Input";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {getRoomDescription} from "../../../../redux/actions/propertyRoomAndRateActions";
import axios from 'axios';
import { GET_ROOM_DESCRIPTION, OPEN_AI } from '../../../../constants/api.constants';
import { getProperty, getAppLang, getUserToken } from '../../../../utils';
import { Animated } from 'react-animated-css';
import { openAI, clearOpenAI } from '../../../../redux/actions/General/OpenAI/openAIActions';
import { makeStyles } from '@material-ui/core/styles';
import { getLanguages } from '../../../../redux/actions/languageActions';
import { propertyProducts } from '../../../../redux/actions/propertyProductsActions';

const useStyles = makeStyles({
  tooltip: {
    fontSize: '1rem',
    fontWeight: 500,
  },
});

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`room-rate-tabpanel-${index}`}
            aria-labelledby={`room-rate-tab-${index}`}
            {...other}
        >
            {value === index && <Box>{children}</Box>}
        </Typography>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `room-rate-tab-${index}`,
        'aria-controls': `room-rate-tabpanel-${index}`,
    };
}

function a12yProps(index) {
    return {
        id: `place-description-tab-${index}`,
        'aria-controls': `room-rate-tabpanel-${index}`,
    };
}

const findChildData = (data, parentId) => {
    let childData = data.filter( (placesCategories) => {
        return placesCategories.parent_id === parentId
    })
    return childData;
}

const PlacesModal = (props) => {

    const placesCategories  = useSelector(props => props.placesGetCategoriesReducer.placesCategories?.place_categories);
    const placeWorkingHours = useSelector(props => props.placesGetCategoriesReducer.placesCategories?.place_working_hours);
    const placeIncludes = useSelector(props => props.placesGetCategoriesReducer.placesCategories?.place_includes);
    const createPlaceStatus = useSelector(props => props.placeCreateReducer.createPlaceStatus?.status);
    const createPlaceError = useSelector(props => props.placeCreateReducer.error);
    const createGetInputsPlaceError = useSelector(props => props.placeCreateReducer.getCategoryError);
    const placeCategoryFieldsReducer = useSelector(props => props.placeCreateReducer);
    const placeCategoryFields = isDefined(placeCategoryFieldsReducer.placeCategoryFields.data) && placeCategoryFieldsReducer.placeCategoryFields.data.place_category_fields;
    const openAIResult = useSelector(props => props?.openAIReducer?.listData);
    const languageList = useSelector(state => state.languagesReducer.languages);
    const propertyProductsReducer = useSelector(state => state.propertyProductsReducer);

    const dispatch = useDispatch();
    const classes = useStyles();

    const { t } = useTranslation();

    const [selectedCategory, setSelectedCategory] = useState();
    const [selectedChildId, setSelectedChildId] = useState([]);
    const [lastSelectedId, setLastSelectedId] = useState([]);
    const [workingHour, setWorkingHour] = useState();
    const [include, setInclude] = useState();
    const [placeName, setPlaceName] = useState();
    const [isReservation, setIsReservation] = useState();
    const [childData, setChildData] = useState([]);
    const [render, setRender] = useState(false);
    const [value, setValue] = React.useState(0);
    const [description, setDescription] = useState(props.descriptionData);
    const [descriptionTabValue, setDescriptionTabValue] = React.useState(0);
    const [descriptionMaxCharCount] = React.useState(2000);
    const [descriptionCharCount, setDescriptionCharCount] = React.useState(isDefined(props.descriptionData) && Object.keys(props.descriptionData).length > 0  ? props.descriptionData.map(value =>{
        return value.description === null ? 0 : value.description.length
    }) : []);
    const [state, setState] = useState({
        fields: {}
    });
    const [placeLanguageName, setPlaceLanguageName] = useState([]);
    const [nameTabValue, setNameTabValue] = React.useState(0);
    const [hasLocaleName, setHasLocaleName] = useState(false);
    const [nameCharCount, setNameCharCount] = React.useState(isDefined(placeLanguageName) && Object.keys(placeLanguageName).length > 0  ? placeLanguageName.map(value =>{
        return value?.name === null ? 0 : value?.name?.length
    }) : []);
    const [nameMaxCharCount] = React.useState(200);
    const [placeLink, setPlaceLink] = useState(null);
    const [menuLink, setMenuLink] = useState(null);
    const [enableContactForm, setEnableContactForm] = useState(0);
    const [aiLoading, setAiLoading] = useState(false);
    const [translateLoading, setTranslateLoading] = useState(false);
    const [isTranslateMode, setIsTranslateMode] = useState(false);
    const [translateSourceLang, setTranslateSourceLang] = useState("");
    const [showSnackbar, setShowSnackbar] = useState(false);

    useEffect(() => {
        if (placeLanguageName?.length < 1) {
            getNullDesc();
        }
    },[]);

    useEffect(() => {
        if (!propertyProductsReducer.get_products) {
            dispatch(propertyProducts());
        }
    }, []);

    useEffect(() => {
        if (placeLanguageName?.length > 0) {
            placeLanguageName.map((data =>{
               data['name'] = data['description'];
               delete data['description'];
               return data;
            }))
        }
    },[placeLanguageName]);

    useEffect(() => {
        if (openAIResult && typeof openAIResult === "object" && Object.keys(openAIResult).length > 0) {
            handleAIResponse(openAIResult);
            setAiLoading(false);
        }
    }, [openAIResult]);

    const getNullDesc = () => {  
        axios.get(GET_ROOM_DESCRIPTION, {
          headers: {
            "Accept": "application/json",
            authToken: localStorage.getItem('auth'),
            "Content-Type": "application/json",
            "language": getAppLang(),
          }
        }).then((result) => {
            setPlaceLanguageName(result.data.data)
        }).catch(function (error) {
          console.log(error);
        });
      }

    const handleChange = (event, newValue) => {
        dispatch(getPlaceCategoryFieldsClearStatus());

        setValue(newValue);
        setState({ fields: {} })
    };

    const handleChangeDescriptionTab = (event, newValue) => {
        setDescriptionTabValue(newValue);
    };

    const handleChangeCharCount = index => (e) => {
        let tempCount = [...descriptionCharCount];
        tempCount[index] = e.target.value.length;
        setDescriptionCharCount(tempCount);

        let updatedDescriptions = description.map((desc, i) =>
            i === index ? { ...desc, description: e.target.value } : desc
        );
        setDescription(updatedDescriptions);
    };

    const handleChangeCategory = ({target}) => {
        if(target.value === null) return 0;
        setSelectedCategory(target.value)
        setLastSelectedId(target.value)
        setSelectedChildId([]);
        let childData = findChildData(placesCategories, target.value);
        setChildData( [childData]  )
        setRender(!render)
    }

    const handleChangeChild = (e,index) => {
        if(e.target.value === null) return 0;

        let findedChildData = findChildData(placesCategories,e.target.value)

        if (findedChildData.length === 0 ){
            let temp = childData;
            temp.splice(index+1, temp.length);
            setChildData(temp);
            setLastSelectedId(e.target.value)
            let tempChildIds = selectedChildId;
            tempChildIds.splice(index, tempChildIds.length);
            tempChildIds.push(e.target.value)
            setSelectedChildId(tempChildIds)

            setRender(!render)
            return 0;
        }


        if ((index+1) < childData.length ){
            let temp = childData;
            temp.splice(index+1, temp.length);
            temp.push(findedChildData);
            setLastSelectedId(e.target.value)
            setChildData(temp);

            let tempChildIds = selectedChildId;
            tempChildIds.splice(index+1, tempChildIds.length);


        }else{
            setLastSelectedId(e.target.value);
            setChildData(prevState => [...prevState, findedChildData]);
            setSelectedChildId(prevState => [...prevState, e.target.value]);
        }

        setRender(!render)
    }

    const handleChangeWorkingHour = ({target}) => {
        if(target.value === null) return 0;
        setWorkingHour(target.value);
    }

    const handleChangeInclude = ({target}) => {
        if(target.value === null) return 0;
        setInclude(target.value);
    }
    const handleChangeReservation = ({target}) => {
        if(target.value === null) return 0;
        setIsReservation(target.value);
    }

    const handleChangePlaceName = (e) => {
        setPlaceName(e.target.value)
    }

    const handleChangeNameTab = (event, newValue) => {
        setNameTabValue(newValue);
    };

    const handleNameCharCount = index => (e) => {
        let tempCount = [...nameCharCount];

        tempCount[index] = e.target.value.length;

        setNameCharCount(tempCount);

        let values = placeLanguageName;
        values[index]["name"] = e.target.value === "" ? null : e.target.value;
    };

    const handleHasLocaleName = (e) => {
        setHasLocaleName(!hasLocaleName)
    }

    const handleChangePlaceLink = (e) => {
        setPlaceLink(e.target.value)
    }

    const handleChangeMenuLink = (e) => {
        setMenuLink(e.target.value);
    }
    
    const handleEnableContactForm  = ({target}) => {
        if(target.value === null) return 0;
        setEnableContactForm(target.value);
    }

    useEffect( ()=> {
        if ( (createPlaceStatus === 200)  ){

            // List Yeniden Çekilecek
            dispatch(getPlaceList());
            dispatch(getRoomDescription());

            //Modal Kapatılacak ;
            props.modalClose();

            // Status temizleniyor
            dispatch(createPlaceClearStatus());
        } else {
            setValue(0)
            setState({ fields: {} })
        }
    },[render, createPlaceStatus,createPlaceError] )

    useEffect( ()=> {

        if (placeCategoryFieldsReducer.placeCategoryFields.status === 200) {
            setValue(1)
        }
    },[render, placeCategoryFieldsReducer, createGetInputsPlaceError] )

    const onSubmit = (e) => {
        e.preventDefault();
        if (hasLocaleName === false) {
            placeLanguageName.map((data => {
                data.name = null;
            }))
        }

        let params = {
            place_category_id: lastSelectedId,
            place_working_hour_id: workingHour,
            include : include,
            name : placeName,
            reservation_requirement : isReservation ? 1 : 0,
            field_values: state.fields,
            description: description,
            language_name: placeLanguageName,
            web: placeLink || null,
            menu: (selectedCategory === 1 || selectedCategory === 130 || selectedCategory === 133) ? menuLink : null,
            contact_form: enableContactForm ? 1 : 0
        }

        dispatch(createPlace(params));
    };

    const getFields = (e) => {
        e.preventDefault();
        dispatch(getPlaceCategoryFields(lastSelectedId, null));
    };

    const handleChangeFields = (e, key, type, value, name) => {
        e.preventDefault();
        let values = state.fields;

        if (type === "multi") {
            let selectedValues =  value.map((item) => {return item.option_id})

            values[key] = {
                field_id: key,
                field_value: selectedValues,
                field_name: name
            };
        }
        else if (type === "slider") {
            values[key] = {
                field_id: key,
                field_value: value === "minSliderValue" && e.target.value,
                field_name: name,
                field_max_value: value === "maxSliderValue" && e.target.value
            };
        } else if (type === "inputunit") {
            values[key] = {
                field_id: key,
                field_value: value === "unitInputValue" && e.target.value,
                field_name: e.target.name,
                field_unit_value: value === "unitSelectValue" && e.target.value
            };
        } else {
            values[key] = {
                field_id: key,
                field_value: e.target.value,
                field_name: e.target.name
            };
        }
        setState({ ...state, values });
    };

    const handleAIResponse = (aiData) => {
        let updatedDescriptions = description?.map(desc => ({ ...desc })) ?? [];

        // Gelen AI verisini ilgili dildeki description'a yaz
        Object.keys(aiData || {}).forEach(lang => {
            const idx = updatedDescriptions.findIndex(d => d.language_code === lang);
            if (idx !== -1 && aiData[lang]) {
                updatedDescriptions[idx].description = aiData[lang];
            }
        });

        setDescription(updatedDescriptions);

        setDescriptionCharCount(
            updatedDescriptions.map(d => d.description ? d.description.length : 0)
        );
        dispatch(clearOpenAI());
    };

    const handleAIDescription = index => async (e) => {
        const langCodes = (languageList || []).filter(lang => lang.name !== "Turkish").map(lang => lang?.name).join(', ');
        setAiLoading(true);
        let aiMessage = [
            {
                role: "system",
                content: "Sen bir SEO uzmanısın. Cevaplarını SADECE JSON formatında ver, veriye sadece açıklamayı dahil et, object keyleri sadece dil kodu olsun. Otelin Mekanı için özgün, açıklayıcı ve SEO uyumlu açıklamalar üret"
            },
            {
                role: "user",
                content: `Aşağıdaki bilgilerle ${getPropertyName() + " isimli otelin" || "bu otelin"} mekanı için özgün ve SEO uyumlu bir açıklama oluştur: mekanın ismi ${placeName}, mekanın kategorisi ise ${t(placesCategories?.find(c => c.id === selectedCategory)?.language_key || "")}. Açıklama maksimum 300 karakter olsun ve kullanıcıyı bilgilendirici olsun. Şehir bilgisini açıklamada dahil etme. Türkçe dilinde oluştur ve ${langCodes} dillerine çevir.`
            }
        ];  
        dispatch(openAI({ message: aiMessage }));
    };

    const handleTranslate = (index, langCode) => async (e) => {
        const currentDesc = description.find(d => d.language_code === langCode);

        if (!currentDesc?.description || currentDesc.description.trim() === "") {
            return;
        }

        setTranslateLoading(true);

        const sourceLangName = (languageList || []).find(lang => lang?.code === langCode)?.name || langCode;
        const targetLangs = (languageList || [])
            .map(lang => ({ code: lang?.code, name: lang?.name }))
            .filter(lang => lang.code && lang.code !== langCode);

        const headers = {
            'Content-Type': 'application/json',
            'authToken': getUserToken(),
            'language': getAppLang(),
        };

        const makeRequest = (targetLang) => {
            const body = {
                params: {
                    property_id: getProperty(),
                    query: {
                        model: "gpt-4.1-mini",
                        response_format: { type: "json_object" },
                        messages: [
                            {
                                role: "system",
                                content: "Sen profesyonel bir çevirmensin. Cevabını SADECE JSON formatında ver, tek bir key olsun: dil kodu (örn: {\"en\": \"...\"})."
                            },
                            {
                                role: "user",
                                content: `Aşağıdaki ${sourceLangName} dilindeki metni ${targetLang.name} diline çevir. Metin: "${currentDesc.description}". Çeviriyi JSON formatında ver, key olarak "${targetLang.code}" kullan.`
                            }
                        ]
                    }
                }
            };
            return axios.post(OPEN_AI, body, { headers })
                .then(res => res.data.data)
                .catch(() => null);
        };

        try {
            const results = await Promise.all(targetLangs.map(lang => makeRequest(lang)));

            const merged = {};
            results.forEach(result => {
                if (result && typeof result === 'object') {
                    Object.assign(merged, result);
                }
            });

            handleTranslateResponse(merged, langCode);
        } finally {
            setTranslateLoading(false);
        }
    };

    const handleTranslateResponse = (aiData, sourceLangCode) => {
        let updatedDescriptions = description.map(desc => ({ ...desc }));

        Object.keys(aiData || {}).forEach(lang => {
            if (lang !== sourceLangCode) {
                const idx = updatedDescriptions.findIndex(d => d.language_code === lang);
                if (idx !== -1 && aiData[lang]) {
                    updatedDescriptions[idx].description = aiData[lang];
                }
            }
        });

        setDescription(updatedDescriptions);
        setDescriptionCharCount(
            updatedDescriptions.map(d => d.description ? d.description.length : 0)
        );
        setShowSnackbar(true);
        dispatch(clearOpenAI());
    };

    const contentProduct = !propertyProductsReducer.fetching &&
        isDefined(propertyProductsReducer.get_products)
            ? Object.values(propertyProductsReducer.get_products.data).find(item => item.route === "content")
            : null;

    const showAIContent = isDefined(contentProduct) &&
        isDefined(contentProduct.parameters) &&
        (contentProduct.parameters.length === 0 || contentProduct.parameters.some(p => p?.product_parameter_id === 102 && p?.is_selected === 1));

    const sysLang = getAppLang();
    const sortedDescriptions = description.map((item, idx) => ({ ...item, originalIndex: idx })).sort((a, b) => {
        // Önce tr, sonra en gelsin
        if (a.language_code === "tr") return -1;
        if (b.language_code === "tr") return 1;
        if (a.language_code === "en") return -1;
        if (b.language_code === "en") return 1;
        // Diğer diller alfabetik
        return a.language_code.localeCompare(b.language_code);
    });

    const descriptionList = sortedDescriptions?.map((title, index)=>{
        const hasDescription = title?.description && title?.description.trim() !== "";
        return (
            <TabPanel value={descriptionTabValue} index={index} className="w-100">
                {showAIContent && (
                    <Box display="flex" justifyContent="flex-end" mb={1} gap={1}>
                        <Tooltip title={placeName === "" || placeName === undefined ? t('enw-ai_place_name_required') : t('enw-create_with_ai-title')} classes={{ tooltip: classes.tooltip }} arrow>
                            <span>
                                <ButtonAtm
                                    size="small"
                                    variant="outlined"
                                    onClick={handleAIDescription(title.originalIndex)}
                                    startIcon={
                                        aiLoading ? 
                                            <i style={{fontSize: "16px", marginLeft: "8px"}} className="fas fa-spinner-third fa-spin"></i>
                                            :
                                            <svg xmlns="http://www.w3.org/2000/svg" style={{color: "#d71f26", marginLeft: "8px"}} className="competitor-ai-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"></path>
                                                <path d="M20 3v4"></path>
                                                <path d="M22 5h-4"></path>
                                                <path d="M4 17v2"></path>
                                                <path d="M5 18H3"></path>
                                            </svg>
                                    }
                                    className="mt-12 create-with-ai"
                                    style={{borderRadius: "8px", color: "#000", textTransform: "none", marginRight: 8}}
                                    buttontext={t('enw-create_with_ai-title')}
                                    disabled={placeName === "" || placeName === undefined || aiLoading || translateLoading}
                                />
                            </span>
                        </Tooltip>
                        <ButtonAtm
                            size="small"
                            variant="outlined"
                            onClick={handleTranslate(title.originalIndex, title.language_code)}
                            className="mt-12 create-with-ai"
                            startIcon={
                                translateLoading ?
                                    <i style={{fontSize: "16px", marginLeft: "8px"}} className="fas fa-spinner-third fa-spin"></i>
                                    :
                                    <svg fill="#d71f26" style={{width: "1.5rem", height: "1rem", fontSize: 20}} viewBox="0 0 52 52" data-name="Layer 1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"><path d="M39,18.67H35.42l-4.2,11.12A29,29,0,0,1,20.6,24.91a28.76,28.76,0,0,0,7.11-14.49h5.21a2,2,0,0,0,0-4H19.67V2a2,2,0,1,0-4,0V6.42H2.41a2,2,0,0,0,0,4H7.63a28.73,28.73,0,0,0,7.1,14.49A29.51,29.51,0,0,1,3.27,30a2,2,0,0,0,.43,4,1.61,1.61,0,0,0,.44-.05,32.56,32.56,0,0,0,13.53-6.25,32,32,0,0,0,12.13,5.9L22.83,52H28l2.7-7.76H43.64L46.37,52h5.22Zm-15.3-8.25a23.76,23.76,0,0,1-6,11.86,23.71,23.71,0,0,1-6-11.86Zm8.68,29.15,4.83-13.83L42,39.57Z"/></svg>
                            }
                            style={{borderRadius: "8px", color: "#000", textTransform: "none"}}
                            buttontext={t('btn-translate')}
                            disabled={!hasDescription || aiLoading || translateLoading}
                        />
                    </Box>
                )}
                <TextField
                    name={title.language_code}
                    type="text"
                    variant="outlined"
                    className={showAIContent ? 'text-capitalize mt-0' : 'text-capitalize mt-10' }
                    onChange={handleChangeCharCount(title.originalIndex)}
                    value={description[title.originalIndex]?.description || ""}
                    label={ t('enw-input-description') + " - " + title.language_code }
                    multiline={true}
                    fullWidth
                    required={false}
                    rows={2}
                    inputProps={{maxLength : descriptionMaxCharCount}}
                />
                <div style={{ width: '100%'}}>
                    <p style={{ float : 'right'}}> { descriptionCharCount[title.originalIndex] }/ {descriptionMaxCharCount}</p>
                </div>
            </TabPanel>
        );
    })

    const descriptionTabs = sortedDescriptions?.map((title, value) => {
        const flag = (
            <Grid container className="brand-desc-flag" spacing={1}>
                <Grid item sm={3}>
                    <img src={`${process.env.PUBLIC_URL}/assets/img/language/${title.language_code}.svg`} alt={title.language_code} />
                </Grid>
                <Grid item sm={2}>
                    {title.language_code}
                </Grid>
            </Grid>
        );
        return (
            <Tab label={flag} {...a12yProps(value)} />
        );
    });

    const sortedLanguageNames = isDefined(placeLanguageName)
        ? placeLanguageName.map((item, idx) => ({ ...item, originalIndex: idx })).sort((a, b) => {
            if (a.language_code === "tr") return -1;
            if (b.language_code === "tr") return 1;
            if (a.language_code === "en") return -1;
            if (b.language_code === "en") return 1;
            return a.language_code.localeCompare(b.language_code);
        })
        : [];

    const nameTabs = sortedLanguageNames.map((title, value) => {
        const flag = (
            <Grid container className="brand-desc-flag" spacing={1}>
                <Grid item sm={3}>
                    <img src={`${process.env.PUBLIC_URL}/assets/img/language/${title.language_code}.svg`} alt={title.language_code} />
                </Grid>
                <Grid item sm={2}>
                    {title.language_code}
                </Grid>
            </Grid>
        );
        return (
            <Tab label={flag} {...a12yProps(value)} key={title.language_code} />
        );
    });

    const nameList = sortedLanguageNames.map((title, index) => {
        return (
            <TabPanel value={nameTabValue} index={index} className="w-100" key={title.language_code}>
                <TextField
                    name={title?.language_code}
                    type="text"
                    variant="outlined"
                    className="text-capitalize"
                    onChange={handleNameCharCount(title.originalIndex)}
                    value={placeLanguageName[title.originalIndex]?.name || ""}
                    label={t('enw-input-place_name') + " - " + title?.language_code}
                    multiline={true}
                    fullWidth
                    required={false}
                    rows={1}
                    inputProps={{ maxLength: nameMaxCharCount }}
                />
                <div style={{ width: '100%' }}>
                    <p style={{ float: 'right' }}> {nameCharCount[title.originalIndex] === undefined ? 0 : nameCharCount[title.originalIndex]}/ {nameMaxCharCount}</p>
                </div>
            </TabPanel>
        );
    });

    return (
        <div>
            <ValidatorForm onSubmit={getFields} onError={errors => console.log(errors)}>
                <AppBar className="room-rate-tab-title" position="static">
                    <Tabs className="room-rate-tabFont" value={value} onChange={handleChange} aria-label="room-rate-tab">
                        <Tab label={ t('enw-content-place_details-title') } {...a11yProps(0)} />
                        <ButtonAtm className={value === 1 ? "bed-type-title" : "passive-tab"} buttontext={ t('enw-content-place_facts-add_place-title') } />
                    </Tabs>
                </AppBar>
                <ColAtm xs={12} className="select-room-types">
                </ColAtm>
                <TabPanel value={value} index={0}>
                    <ColAtm xs={12} className="select-room-types">
                        {isDefined(createPlaceError?.response) && <Alert className="w-100 mt-22" severity="error">{createPlaceError?.response?.data?.message}</Alert>}
                        {isDefined(createGetInputsPlaceError?.response) && <Alert className="w-100 mt-22" severity="error">{createGetInputsPlaceError?.response?.data?.message}</Alert>}
                        <ColAtm xs={12} className="form-group">
                            <SelectValidator
                                onChange={handleChangeCategory}
                                className="form-control"
                                variant="outlined"
                                fullWidth
                                label={ t('enw-content-place_categories') }
                                value={selectedCategory}
                                validators={['required']}
                                errorMessages={[ t("enw-notification_this_is_required") ]}
                            >
                                {
                                    placesCategories.length > 0 && placesCategories.filter( (placesCategories) => {
                                        return placesCategories.parent_id === null
                                    }).map((category) => (
                                        <MenuItem value={category.id} >
                                            { t(category.language_key) }
                                        </MenuItem>
                                    ))
                                }
                            </SelectValidator>
                        </ColAtm>
                        {
                            childData.length > 0 && childData.map( (item,key) => (
                                <ColAtm xs={12} className="form-group">
                                    <SelectValidator
                                        onChange={(e) => handleChangeChild(e,key)}
                                        className="form-control"
                                        variant="outlined"
                                        fullWidth
                                        label={ t('enw-input-category_type') }
                                        value={selectedChildId[key]}
                                        validators={['required']}
                                        errorMessages={[ t("enw-notification_this_is_required") ]}
                                    >
                                        {
                                            item.map((category) => (
                                                <MenuItem value={category.id} >
                                                    { t(category.language_key) }
                                                </MenuItem>
                                            ))
                                        }
                                    </SelectValidator>
                                </ColAtm>
                            ))
                        }
                        <ColAtm xs={12} className="form-group">
                            <TextValidator
                                label={ t('enw-input-place_name') }
                                name="place_name"
                                type="text"
                                fullWidth
                                autoComplete="off"
                                value={placeName}
                                onChange={handleChangePlaceName}
                                variant="outlined"
                                validators={['required']}
                                errorMessages={[ t("enw-notification_this_is_required") ]}
                            />
                        </ColAtm>
                        <label onClick={handleHasLocaleName} style={{marginBottom: "6px"}} className={"traditional-name " + ( hasLocaleName ? 'active-button' : '')} htmlFor="haveANonEnglishName">
                        <i className={ hasLocaleName ? 'fa fa-check' : ''} aria-hidden="true" />
                        { t('enw-btn-place_have_local_name')}
                        </label>
                        {   
                            hasLocaleName &&
                            <Animated animationIn="fadeIn" style={{width:"100%"}} animationInDuration={1000} isVisible={true}>
                                <ColAtm className="d-block brand-container place-desc mb-0">
                                    <ColAtm>
                                        <AppBar className="room-rate-tab-title" position="static">
                                            <Tabs className="room-rate-tabFont"
                                                value={nameTabValue}
                                                onChange={handleChangeNameTab}
                                                aria-label="place-description-tab"
                                                variant="scrollable"
                                                scrollButtons="on"
                                            >
                                                {nameTabs}
                                            </Tabs>
                                        </AppBar>
                                        {nameList}
                                    </ColAtm>
                                </ColAtm>
                            </Animated>
                        }
                        <ColAtm xs={12} className="form-group">
                            <SelectValidator
                                onChange={handleChangeWorkingHour}
                                className="form-control"
                                variant="outlined"
                                fullWidth
                                value={workingHour}
                                label={ t('enw-input-working_hour') }
                                validators={['required']}
                                errorMessages={[ t("enw-notification_this_is_required") ]}
                            >
                                {
                                    placeWorkingHours.length > 0 && placeWorkingHours.map( (placesWorkingHour) => (
                                        <MenuItem value={placesWorkingHour.id} >
                                            { t(placesWorkingHour.language_key) }
                                        </MenuItem>
                                    ))
                                }
                            </SelectValidator>
                        </ColAtm>
                        <ColAtm xs={12} className="form-group">
                            <SelectValidator
                                onChange={handleChangeInclude}
                                className="form-control"
                                variant="outlined"
                                fullWidth
                                value={include}
                                label={ t('enw-input-include') }
                                validators={['required']}
                                errorMessages={[ t("enw-notification_this_is_required") ]}
                            >
                                {
                                    placeIncludes.length > 0 && placeIncludes.map( (placeInclude) => (
                                        <MenuItem value={placeInclude.id} >
                                            { t(placeInclude.language_key) }
                                        </MenuItem>
                                    ))
                                }
                            </SelectValidator>
                        </ColAtm>
                        <ColAtm xs={12} className="form-group">
                            <SelectValidator
                                onChange={handleChangeReservation}
                                className="form-control"
                                variant="outlined"
                                fullWidth
                                value={isReservation}
                                label={ t('enw-content-add_place-is_reservation_required') }
                                validators={['required']}
                                errorMessages={[ t("enw-notification_this_is_required") ]}
                            >
                                <MenuItem value={0} >
                                    { t('enw-input-checkbox-no') }
                                </MenuItem>
                                <MenuItem value={1} >
                                    { t('enw-input-checkbox-yes') }
                                </MenuItem>
                            </SelectValidator>
                        </ColAtm>
                        <ColAtm xs={12} className="form-group">
                            <TextValidator
                                label={ t('enw-input-place_link') }
                                name="place_link"
                                type="text"
                                fullWidth
                                autoComplete="off"
                                value={placeLink}
                                onChange={handleChangePlaceLink}
                                variant="outlined"
                                validators={['matchRegexp:^(https?:\\/\\/)?((([-a-z0-9]{1,63}\\.)*?[a-z0-9]([-a-z0-9]{0,253}[a-z0-9])?\\.[a-z]{2,63})|((\\d{1,3}\\.){3}\\d{1,3}))(:\\d{1,5})?((\\/|\\?)((%[0-9a-f]{2})|[-\\w\\+\\.\\?\\/@~#&=])*)?$']}
                                errorMessages={[ t("enw-input-place_link-validation_error") ]}
                                // validators={['required']}
                                // errorMessages={[ t("enw-notification_this_is_required") ]}
                            />
                        </ColAtm>
                        {
                            selectedCategory && (selectedCategory === 1 || selectedCategory === 130 || selectedCategory === 133) &&
                            <ColAtm xs={12} className="form-group">
                                <TextValidator
                                    label={ t('enw-input-menu_link') }
                                    name="menu_link"
                                    type="text"
                                    fullWidth
                                    autoComplete="off"
                                    value={menuLink}
                                    onChange={handleChangeMenuLink}
                                    variant="outlined"
                                    validators={['matchRegexp:^(https?:\\/\\/)?((([-a-z0-9]{1,63}\\.)*?[a-z0-9]([-a-z0-9]{0,253}[a-z0-9])?\\.[a-z]{2,63})|((\\d{1,3}\\.){3}\\d{1,3}))(:\\d{1,5})?((\\/|\\?)((%[0-9a-f]{2})|[-\\w\\+\\.\\?\\/@~#&=])*)?$']}
                                    errorMessages={[ t("enw-input-place_link-validation_error") ]}
                                />
                            </ColAtm>
                        }
                        <ColAtm xs={12} className="form-group">
                            <SelectValidator
                                onChange={handleEnableContactForm}
                                className="form-control"
                                variant="outlined"
                                fullWidth
                                value={enableContactForm}
                                label={ t('myweb-contact-contact_form-title') }
                            >
                                <MenuItem value={0} >
                                    { t('enw-input-checkbox-no') }
                                </MenuItem>
                                <MenuItem value={1} >
                                    { t('enw-input-checkbox-yes') }
                                </MenuItem>
                            </SelectValidator>
                        </ColAtm>
                        <ColAtm className="d-block brand-container place-desc">
                            <ColAtm>
                                <AppBar className="room-rate-tab-title" position="static">
                                    <Tabs className="room-rate-tabFont"
                                          value={descriptionTabValue}
                                          onChange={handleChangeDescriptionTab}
                                          aria-label="place-description-tab"
                                          variant="scrollable"
                                          scrollButtons="on"
                                    >
                                        {descriptionTabs}
                                    </Tabs>
                                </AppBar>
                                {descriptionList}
                            </ColAtm>
                        </ColAtm>
                        <ColAtm md={12}>
                            <ButtonAtm
                                type="submit"
                                className="m-auto room-rate-modal-save bg-red"
                                buttontext={ t('btn-next') }
                                color="primary"
                            />
                        </ColAtm>
                    </ColAtm>
                </TabPanel>
                <TabPanel value={value} index={1} className="mt-22">
                    {Object.values(placeCategoryFields).sort((a, b) => a.field_order_number > b.field_order_number ? 1:-1).map((field)=> {
                        return <ColAtm xs={12} className="select-room-types">
                            {
                                field.field_element === "input" ?
                                <ColAtm xs={12} className="form-group">
                                    <InputAtm
                                        name={field.field_name}
                                        type={field.field_type === "text" ? field.field_type : ""}
                                        variant="outlined"
                                        autoComplete="off"
                                        onInput={field.field_type === "number" ? (e) => { e.target.value = e.target.value.replace(/[^0-9]/g, '') } : ""}
                                        label={ t(field.field_language_key) }
                                        onChange={(e) => handleChangeFields(e, field.field_id, "single")}
                                    />
                                </ColAtm>
                                :
                                field.field_element === "select" ?
                                <ColAtm xs={12} className="form-group">
                                        <FormControl variant="outlined" fullWidth>
                                        <InputLabel>{ t(field.field_language_key) }</InputLabel>
                                        <Select
                                            className="form-control"
                                            name={field.field_name}
                                            variant="outlined"
                                            fullWidth
                                            label={ t(field.field_language_key) }
                                            onChange={(e) => handleChangeFields(e, field.field_id, "single")}
                                        >
                                            {
                                                Object.values(field.options).map( (options,index) => (
                                                    <MenuItem value={options.option_id}>
                                                        { t(options.option_language_key) }
                                                    </MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </FormControl>
                                    </ColAtm>
                                :
                                field.field_element === "slider" ?
                                <Grid container spacing={3}>
                                        <Grid item xs={6}>
                                            <TextValidator
                                                label={ t('enw-input-min_age') }
                                                name="place_name"
                                                type="text"
                                                fullWidth
                                                autoComplete="off"
                                                onChange={(e) => handleChangeFields(e, field.field_id, "slider", "minSliderValue", field.field_name)}
                                                variant="outlined"
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextValidator
                                                label={ t('enw-input-max_age') }
                                                name="place_name"
                                                type="text"
                                                fullWidth
                                                autoComplete="off"
                                                onChange={(e) => handleChangeFields(e, field.field_id+"_max", "slider", "maxSliderValue", field.field_name)}
                                                variant="outlined"
                                            />
                                        </Grid>
                                    </Grid>
                                :
                                field.field_element === "multiselect" ?
                                <ColAtm xs={12} className="form-group">
                                    <Autocomplete
                                        id="placesMulti"
                                        options={Object.values(field.options).sort((a, b) => convertAccentedCharacters(t(a.language_key)) > convertAccentedCharacters(t(b.language_key)) ? 1:-1)}
                                        getOptionLabel={option => t(option.option_language_key)}
                                        multiple
                                        name={field.field_name}
                                        className="w-100"
                                        filterSelectedOptions
                                        onChange={(e, value) => handleChangeFields(e, field.field_id, "multi", value, field.field_name)}
                                        renderInput={params => (
                                            <TextField
                                                {...params}
                                                variant="outlined"
                                                name={params.field_name}
                                                label={ t(field.field_language_key) }
                                                placeholder={ t(field.field_language_key) }
                                                fullWidth
                                            />
                                        )}
                                    />
                                </ColAtm>
                                :
                                field.field_element === "inputunit" ?
                                    <Grid container spacing={3}>
                                        <Grid item xs={12} md={8}>
                                            <InputAtm
                                                name={field.field_name}
                                                type={field.field_type === "text" ? field.field_type : ""}
                                                variant="outlined"
                                                autoComplete="off"
                                                onInput={field.field_type === "number" ? (e) => { e.target.value = e.target.value.replace(/[^0-9]/g, '') } : ""}
                                                label={ t(field.field_language_key) }
                                                onChange={(e) => handleChangeFields(e, field.field_id, "inputunit", "unitInputValue", e.target.value)}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4} className="form-group">
                                            <FormControl variant="outlined" fullWidth>
                                                <InputLabel>{ t(field.field_attribute.unit_label) }</InputLabel>
                                                <Select
                                                    className="form-control"
                                                    name={field.field_name}
                                                    variant="outlined"
                                                    fullWidth
                                                    label={ t(field.field_attribute.unit_label) }
                                                    onChange={(e) => handleChangeFields(e, field.field_id+"_unit", "inputunit", "unitSelectValue")}
                                                >
                                                    {
                                                        Object.values(field.field_units).map( (options, index) => (
                                                            <MenuItem value={options.id}>
                                                                { t(options.language_key) }
                                                            </MenuItem>
                                                        ))
                                                    }
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                    :
                                <></>
                            }
                        </ColAtm>
                    })}
                    <ColAtm className="mt-22" md={12}>
                        <ButtonAtm
                            className="m-auto room-rate-modal-save bg-red"
                            type="submit"
                            buttontext={ t('btn-save') }
                            color="primary"
                            onClick={onSubmit}
                        />
                    </ColAtm>
                </TabPanel>
            </ValidatorForm>
            <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                open={showSnackbar}
                autoHideDuration={3000}
                onClose={() => setShowSnackbar(false)}
                // style={{ bottom: 80, right: 40, left: 'auto' }}
            >
                <Alert onClose={() => setShowSnackbar(false)} severity="success">
                    {t('enw-translated_to_all_languages')}
                </Alert>
            </Snackbar>
        </div>
    );
}

export default PlacesModal;
